"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardFocusManager = void 0;
var Topics = require("../Data/Topics");
var KeyboardFocusManager = /** @class */ (function (_super) {
    __extends(KeyboardFocusManager, _super);
    function KeyboardFocusManager(_T) {
        var _this = _super.call(this) || this;
        _this._T = _T;
        _this._pubSubTokens = new Array();
        _this._focusPool = new Array();
        _this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_FOCUS_BEGIN, _this.onFocusBegin.bind(_this)));
        _this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_FOCUS_END, _this.onFocusEnd.bind(_this)));
        _this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_REFOCUS, _this.reFocus.bind(_this)));
        return _this;
    }
    KeyboardFocusManager.prototype.destroy = function (pOptions) {
        for (var i = 0; i < this._pubSubTokens.length; ++i) {
            PubSub.unsubscribe(this._pubSubTokens[i]);
        }
        _super.prototype.destroy.call(this, pOptions);
    };
    KeyboardFocusManager.prototype.onFocusBegin = function (pTopic, pFocusable) {
        var focus = this.getFocus();
        this.addChild(focus);
        focus.show(pFocusable);
        this._activeFocus = focus;
    };
    KeyboardFocusManager.prototype.onFocusEnd = function (pTopic, pFocusable) {
        var _this = this;
        if (this._activeFocus === undefined) {
            return;
        }
        if (this._activeFocus.target !== pFocusable) {
            return;
        }
        var focus = this._activeFocus;
        focus.hide(function () {
            _this.removeChild(focus);
            _this._focusPool.push(focus);
        });
        this._activeFocus = undefined;
    };
    KeyboardFocusManager.prototype.reFocus = function () {
        if (this._activeFocus !== undefined) {
            this._activeFocus.redraw();
        }
    };
    KeyboardFocusManager.prototype.getFocus = function () {
        var focus;
        if (this._focusPool.length > 0) {
            focus = this._focusPool.pop();
        }
        else {
            focus = new this._T();
        }
        return focus;
    };
    return KeyboardFocusManager;
}(PIXI.Container));
exports.KeyboardFocusManager = KeyboardFocusManager;
//# sourceMappingURL=KeyboardFocusManager.js.map